import React from 'react'

import { SectionContainerStyled, SectionInnerStyled, SectionStyled, SectionHeadStyled, SectionBodyStyled } from './styles'
import { Text, Box } from 'theme-ui'
import { SectionProps } from './types'

import Image from './../../atoms/Image'

const Section: React.FC<SectionProps> = ({
  id,
  icon,
  heading,
  isHeadingGreen,
  isMainHeading,
  subheading,
  isSubheadingBold,
  description,
  body,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding
}) => (
  <SectionContainerStyled
    as="section"
    {...{ id }}
    sx={{
      backgroundColor: bgColor ? `${bgColor}` : null,
      paddingTop: paddingTop ? paddingTop : null,
      paddingBottom: paddingBottom ? paddingBottom : null
    }}
  >
    <SectionInnerStyled variant={inner}>
      <SectionStyled>
        {heading && (
          <SectionHeadStyled
            sx={{
              paddingBottom: headingPadding ? headingPadding : null
            }}
          >
            {icon && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: ['1.625rem', '2rem'],
                  height: '2.75rem',
                  ' > *': {
                    width: 'auto'
                  }
                }}
              >
                <Image objectFit="contain" fluid={icon.childImageSharp} alt={icon.alt} />
              </Box>
            )}
            <Text
              sx={{
                variant: 'headingRaleway2',
                fontFamily: 'secondary',
                fontWeight: 'bold',
                color: isHeadingGreen ? 'green' : 'black'
              }}
              as={isMainHeading ? 'h1' : 'h2'}
            >
              {heading}
            </Text>
            {subheading && (
              <Text
                sx={{
                  variant: 'headingMontserrat3',
                  marginTop: ['16px', '10px'],
                  fontWeight: isSubheadingBold ? 'bold' : 'regular'
                }}
                as="p"
              >
                {subheading}
              </Text>
            )}
            {description && (
              <Box
                sx={{
                  variant: 'bodyRaleway5',
                  marginTop: '1rem'
                }}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </SectionHeadStyled>
        )}
        <SectionBodyStyled>{body}</SectionBodyStyled>
      </SectionStyled>
    </SectionInnerStyled>
  </SectionContainerStyled>
)

export default Section
